module.exports = __webpack_public_path__ + "static/img/暂无数据横.65e1cca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/暂无数据横.png
// module id = 384
// module chunks = 1